import { AppointmentCancellationReason } from "appointment-experience-client";
import React from "react";
import { Modal, Form } from "react-bootstrap";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  subtitle?: string;
  dropdownTitle?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm: () => void;
  showDropdown?: boolean;
  dropdownOptions?: AppointmentCancellationReason[];
  selectedReason?: string;
  onReasonSelect?: (value: string) => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  title,
  subtitle,
  dropdownTitle,
  message,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  onConfirm,
  showDropdown = false,
  dropdownOptions = [],
  selectedReason,
  onReasonSelect,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <>
        <Modal.Header closeButton>
          <div className="w-100 text-start">
            {title && <Modal.Title id="contained-modal-title-vcenter"><h3>{title}</h3></Modal.Title>}
            {subtitle && (
              <p className="text-muted mb-0">{subtitle}</p>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          {message && <h5 className="text-center">{message}</h5>}

          {dropdownTitle && (
            <p className="mb-1">
              <span className="text-dark">{dropdownTitle}</span>
              <span className="text-danger"> *</span>
            </p>
          )}
          {showDropdown && (
            <Form.Group>
              <Form.Select
                value={selectedReason}
                onChange={(e) => onReasonSelect?.(e.target.value)}
              >
                <option value="" disabled selected hidden>Select Reason</option>
                {dropdownOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.reasonName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-between">
          <button
            type="button"
            className="btn btn-outline-secondary rounded-pill px-6 my-0"
            onClick={onHide}
          >
            {cancelButtonText}
          </button>
          <button
            type="button"
            className="btn btn-danger rounded-pill px-6 my-0"
            onClick={onConfirm}
            disabled={showDropdown && !selectedReason} // disable confirm if dropdown is shown but not selected
          >
            {confirmButtonText}
          </button>
        </Modal.Footer>
      </>
    </Modal>
  );
};

export default ConfirmationModal;
